module.exports = __webpack_public_path__ + "img/icon_real@2x.3b222223.png";